import { useRouteMatch } from "react-router-dom";

const useAllowChanges = () => {
	const editing = !!useRouteMatch("/Voting/:id/editing");
	const newVoting = !!useRouteMatch("/Voting/new");

	const changeable = newVoting || editing;
	return changeable;
};

export default useAllowChanges;
